import { render, staticRenderFns } from "./ReminderMenu.vue?vue&type=template&id=72ce0e6c&"
import script from "./ReminderMenu.vue?vue&type=script&lang=js&"
export * from "./ReminderMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports